import { render, staticRenderFns } from "./Mina_Sidor.vue?vue&type=template&id=1650750b"
import script from "./Mina_Sidor.vue?vue&type=script&lang=js"
export * from "./Mina_Sidor.vue?vue&type=script&lang=js"
import style0 from "./Mina_Sidor.vue?vue&type=style&index=0&id=1650750b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports